<template>
  <div>
    <div class="body-wrapper blog-detail-page ">
      <section class="blogDetailBodyWrapper">
        <div class="container">
          <div class="row">
            <div class="col-lg-9">
            </div>
          </div>
        </div>

        <div class="bodydetailContainer" v-if="this.blog">
          <div class="container">

            <div class="row">
              <div class="col-lg-9">
                <div class="blogTop">
                  <h1>{{ blog.title }}</h1>
                  <p v-html="blog.excerpt"></p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-9">
                <div class="detailWrapper" v-if="blog">


                  <span class="blogDetDate">{{ convertToCustomFormat(blog.date) }}</span>
                  <div class="detailImg">
                    <img :src="blog.featured_image_src" alt="" width="614" height="364" />
                  </div>
                  <div v-html="blog.content"></div>

                  <div class="share-section">
                    <div class="share-button" @click="showSharePopup">
                      <span class="share-text">- SHARE THIS</span>
                      <svg width="29" height="31" viewBox="0 0 29 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M17.5365 23.3884L9.44571 18.9756C8.66908 19.7465 7.68158 20.2703 6.60773 20.4808C5.53387 20.6913 4.42173 20.5792 3.41151 20.1585C2.40129 19.7379 1.53821 19.0276 0.931097 18.1171C0.323981 17.2067 0 16.1369 0 15.0426C0 13.9483 0.323981 12.8785 0.931097 11.9681C1.53821 11.0577 2.40129 10.3473 3.41151 9.92671C4.42173 9.50607 5.53387 9.39394 6.60773 9.60445C7.68158 9.81497 8.66908 10.3387 9.44571 11.1096L17.5365 6.69686C17.2591 5.39495 17.4595 4.03664 18.1012 2.87035C18.7428 1.70406 19.7829 0.807706 21.0311 0.345218C22.2794 -0.117271 23.6524 -0.114993 24.8991 0.351635C26.1458 0.818262 27.1828 1.71806 27.8206 2.88647C28.4584 4.05489 28.6543 5.41385 28.3725 6.71484C28.0907 8.01583 27.35 9.17191 26.2859 9.97167C25.2218 10.7714 23.9053 11.1614 22.5773 11.0703C21.2492 10.9793 19.9984 10.4132 19.0534 9.47561L10.9625 13.8884C11.1244 14.6488 11.1244 15.4348 10.9625 16.1953L19.0534 20.6096C19.9984 19.6721 21.2492 19.106 22.5773 19.0149C23.9053 18.9238 25.2218 19.3138 26.2859 20.1136C27.35 20.9133 28.0907 22.0694 28.3725 23.3704C28.6543 24.6714 28.4584 26.0303 27.8206 27.1988C27.1828 28.3672 26.1458 29.267 24.8991 29.7336C23.6524 30.2002 22.2794 30.2025 21.0311 29.74C19.7829 29.2775 18.7428 28.3812 18.1012 27.2149C17.4595 26.0486 17.2591 24.6903 17.5365 23.3884Z"
                          fill="#6163B0" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="recentPostsWrap col-lg-3">
                <div class="recentPosts" v-if="recentPosts.length">
                  <h4>Recent Posts</h4>
                  <div v-for="recentPost in recentPosts" :key="recentPost.id" class="postWrapper"
                    @click="goToBlogDetail(recentPost.id)">
                    <h5>{{ convertToCustomFormat(recentPost.date) }}</h5>
                    <span>{{ recentPost.title }}</span>
                  </div>
                  <div class="recentPostBtn">
                    <button @click="goToBlogList" class="btn-1 secondary-btn">View More</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div v-if="showShareModal" class="share-modal-overlay" @click="closeSharePopup">
      <div class="share-modal" @click.stop>
        <div class="share-modal-header">
          <div class="share-modal-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>Link Copy</span>
          </div>
          <button class="share-modal-close" @click="closeSharePopup">×</button>
        </div>
        <div class="share-modal-content">
          <div class="share-url-container">
            <div class="share-url-display">
              <span class="share-url-text">{{ currentUrl }}</span>
              <button class="share-copy-btn" @click="copyLink">
                Copy
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showSuccessModal" class="success-modal-overlay" @click="closeSuccessPopup">
      <div class="success-modal" @click.stop>
        <div class="success-modal-header">
          <div class="success-modal-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="#00D4AA" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <polyline points="22,4 12,14.01 9,11.01" stroke="#00D4AA" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Link Copied</span>
          </div>
          <button class="success-modal-close" @click="closeSuccessPopup">×</button>
        </div>
        <div class="success-modal-content">
          <p>Link Copied Successfully.</p>

        </div>
      </div>
    </div>

    <appFooter />
  </div>
</template>

<script>
import pageHeader from "../../components/pageHeader.vue";
import appFooter from "../../layout/landing/appFooter.vue";
import { mapGetters, mapActions } from "vuex";
import { blogs as blogsStoreKeys } from "../../store/keys";

export default {
  components: {
    pageHeader,
    appFooter,
  },
  data() {
    return {
      blogId: null,
      showShareModal: false,
      showSuccessModal: false,
      currentUrl: '',
    };
  },
  metaInfo: {
    title: "BlogDetail | KIPS VIRTUAL",
    titleTemplate: "",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  computed: {
    ...mapGetters(blogsStoreKeys.namespace, blogsStoreKeys.getters),

    blog() {
      if (this.getBlogs.length) {
        const updatedBlog = this.getBlogs.find(blog => blog.id === parseInt(this.$route.params.id));
        if (updatedBlog) {
          return updatedBlog
        }
        else {
          this.$router.push({ name: "landingPageNotFound" }).catch(() => { });
        }
      }
    },
    recentPosts() {
      return this.getBlogs.slice(0, 4);
    },
  },
  mounted() {
    this.fetchBlogData(this.$route.params.id);
    this.currentUrl = window.location.href;
  },
  methods: {
    ...mapActions(blogsStoreKeys.namespace, blogsStoreKeys.actions),

    convertToCustomFormat(isoString) {
      const date = new Date(isoString);
      if (isNaN(date)) return "N/A";
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const day = String(date.getDate()).padStart(2, '0');
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      return `${day} ${month}, ${year}`;
    },

    async fetchBlogData(blogId) {
      this.blogId = blogId;
      await this.fetch_Blogs();
      window.scrollTo(0, 0);
    },

    goToBlogDetail(id) {
      this.$router.replace(`/blogs/detail/${id}`);
      window.scrollTo(0, 0);
    },

    goToBlogList() {
      this.$router.push('/blogs');
    },

    showSharePopup() {
      this.showShareModal = true;
      this.currentUrl = window.location.href;
    },

    closeSharePopup() {
      this.showShareModal = false;
    },

    closeSuccessPopup() {
      this.showSuccessModal = false;
    },

    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.currentUrl);
        this.showShareModal = false;
        this.showSuccessModal = true;

        setTimeout(() => {
          this.showSuccessModal = false;
        }, 3000);
      } catch (err) {
        const textArea = document.createElement('textarea');
        textArea.value = this.currentUrl;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.showShareModal = false;
        this.showSuccessModal = true;

        setTimeout(() => {
          this.showSuccessModal = false;
        }, 3000);
      }
    },
  },

};
</script>

<style scoped>
.share-section {
  margin: 30px 0;
  padding: 20px 0;
  border-top: 1px solid #eee;
}

.share-button {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.share-button:hover {
  opacity: 0.8;
}

.share-text {
  font-weight: 700;
  color: #434343;
  font-size: 14px;
}

.share-modal-overlay,
.success-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(5px);
}

.share-modal,
.success-modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 500px;
  animation: modalSlideIn 0.3s ease;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.share-modal-header,
.success-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
}

.share-modal-title,
.success-modal-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #333;
  font-size: 16px;
}

.share-modal-close,
.success-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}

.share-modal-close:hover,
.success-modal-close:hover {
  color: #333;
}

.share-modal-content,
.success-modal-content {
  padding: 20px 24px 24px;
}

.share-url-container {
  width: 100%;
}

.share-url-display {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
  padding: 8px 8px 8px 21px;
}

.share-url-text {
  color: #000000;
  font-size: 14px;
  font-family: monospace;
  word-break: break-all;
  flex: 1;
  margin-right: 12px;
}

.share-copy-btn {
  background: #6163B0;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 400;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
      border-radius: 4px;
          font-size: 0.778rem;
}

.share-copy-btn:hover {
  background: #4f51a0;
}

.success-modal-content {
  text-align: left;
}

.success-modal-content p {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 14px;
}

.success-modal-icons {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.success-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: white;
  font-size: 16px;
}

.success-icon-pink {
  background: #ff6b9d;
}

.success-icon-green {
  background: #00d4aa;
}

@media (max-width: 768px) {

  .share-modal,
  .success-modal {
    width: 95%;
    margin: 20px;
  }

  .share-url-display {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .share-url-text {
    margin-right: 0;
    text-align: center;
  }

  .share-copy-btn {
    width: 100%;
  }
}
</style>
